import React from 'react';
import { FaExclamationTriangle, FaInfoCircle, FaUpload } from 'react-icons/fa';
import { DocumentSection, DocumentSectionHeader, DocumentList } from './styles';
import DocumentUploadItem from './DocumentUploadItem';

const SECTION_CONFIG = {
  required: {
    icon: FaExclamationTriangle,
    iconColor: '#dc2626',
    title: 'Documentos Obrigatórios'
  },
  conditional: {
    icon: FaInfoCircle,
    iconColor: '#eab308',
    title: 'Documentos Condicionais'
  },
  optional: {
    icon: FaUpload,
    iconColor: '#6b7280',
    title: 'Documentos Adicionais (Opcionais)'
  }
};

const DocumentSectionComponent = ({ type, documents, documentos, onUpload, onRemove, disabled, loading, subtitle, uploadErros = {}, pendentes }) => {
  if (!documents || documents.length === 0) return null;
  
  const config = SECTION_CONFIG[type];
  const Icon = config.icon;
  
  return (
    <DocumentSection>
      <DocumentSectionHeader>
        <Icon style={{ color: config.iconColor }} />
        {config.title}
        {subtitle && <small style={{ marginLeft: '0.5rem', fontWeight: 'normal' }}>{subtitle}</small>}
      </DocumentSectionHeader>
      <DocumentList>
        {documents.map(doc => (
          <DocumentUploadItem
            key={doc.id}
            documento={doc}
            file={documentos[doc.id]}
            erro={uploadErros[doc.id]}
            pendente={pendentes?.has(doc.id)}
            onUpload={onUpload}
            onRemove={onRemove}
            disabled={disabled}
            loading={loading}
          />
        ))}
      </DocumentList>
    </DocumentSection>
  );
};

export default DocumentSectionComponent;